import { EventCategory, fromEnumAsString } from 'in-time-core';

export function getLocalizationKeyForEventCategory(category: EventCategory): string {
  return `enum.eventCategory.${fromEnumAsString(category)}`;
}
